import {Helper} from "@nolimitcity/promo-panel/bin/utils/Helper";
import {ASBonusPickOptions, WINTYPE} from "@nolimitcity/promo-panel/bin/enums/ASEnums";
import {
    ActionSpinOptions,
    ActionSpinSound,
    ASWinData,
    PromoPanelGameConfiguration,
} from "@nolimitcity/promo-panel/bin/interfaces/ASInterfaces";
import {DragonTribe} from "./DragonTribe";
import {DragonTribeGameAssets} from "./DragonTribeGameAssets";
import {DragonTribeSoundConfig} from "./DragonTribeSoundConfig";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {DragonTribeGameModuleConfig} from "./DragonTribeGameModuleConfig";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {IDragonTribeGameData} from "./server/data/IDragonTribeServerData";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {DTReelSymbolL} from "./symbols/DTReelSymbolL";
import {DTReelSymbolH} from "./symbols/DTReelSymbolH";
import {DTReelSymbolM} from "./symbols/DTReelSymbolM";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ScreenEvent} from "@nolimitcity/slot-game/bin/core/screen/event/ScreenEvent";

export class DragonTribePromoPanelConfig implements PromoPanelGameConfiguration {

    constructor() {
    }


    public getActionSpinOptions(): ActionSpinOptions {
        return {
            gameName: "DragonTribe",
            hasActionSpin: true,
            bonusGame: {
                header: () => DragonTribe.api.translations.translate("Pick Bonus Mode"),
                options: [
                    {name: "DRAGON SPINS", id: 1, image: "XNudge.png"},
                    {name: "DRAGON SPINS EXTREME", id: 2, image: "XWays.png"},
                ],
                type: ASBonusPickOptions.PICK_MODE,
                pickNeededForModes: ["FREESPIN_PICK"],
                pickNeededForBuyFeatures: ["FREESPIN"]
            },
            graphics: {backgroundTextureName: DragonTribeGameAssets.MAIN_GAME_BACKGROUND},
            getParsedData: (response: IDragonTribeGameData, bet: number, prevResponse: IDragonTribeGameData): ASWinData => {
                const parsedData: ASWinData = {
                    totalWin: parseFloat(response.accumulatedRoundWin),
                    totalSpinWinnings: this.getWin(response, bet, prevResponse),
                    wasFeatureBuy: response.wasFeatureBuy,
                    freeSpinTriggeredThisSpin: this.isFreeSpinTriggered(response),
                    isBigWin: this.isBigWin(response),
                    winType: WINTYPE.NORMAL,
                    featureName: this.getFeatureName(response),
                    isRoundComplete: this.isRoundComplete(response),
                    isBonusEnd: this.isBonusEnd(response),
                    isWinCapHit: false
                }
                return parsedData;
            }
        };
    }

    public onActionSpinPlaySound(trigger: ActionSpinSound): void {
        if (trigger == ActionSpinSound.WIN) {
            SlotGame.sound.playEffect(DragonTribeSoundConfig.instance.AS_WIN);
        } else if (trigger == ActionSpinSound.BIG_WIN) {
            SlotGame.sound.playEffect(DragonTribeSoundConfig.instance.AS_WIN_BIG);
        }
    }

    onPlayBonusInGame(data: any): void {
        const reels: string[][] = data.evaluatedArea;
        let sym: StateReelSymbol;
        for (let i: number = 0; i < reels.length; i++) {
            for (let j: number = 0; j < reels.length; j++) {
                sym = (Reels.getSymbol(i, j)!);
                let symHeight: number = sym.symHeight;
                sym.replaceWith(reels[i][j], i);

                if (sym.symName === "X") {
                    sym.setVisibility(false);
                    continue;
                }
                if (reels[i][j].includes("M")) {
                    (sym as DTReelSymbolM).updateBackground(symHeight, true);
                } else if (reels[i][j].includes("L")) {
                    (sym as DTReelSymbolL).updateBackground(symHeight, true);
                } else {
                    (sym as DTReelSymbolH).updateBackground(symHeight, true);
                }

                if (reels[i][j].includes("L")) {
                    for (let k: number = 0; k < sym.children.length; k++) {
                        if (sym.children[k] && sym.children[k].name === "symBackground") {
                            (sym.children[k] as PIXI.Sprite).texture = GameResources.getTextures(DragonTribeGameAssets.L_BG[Math.floor(510 / symHeight) - 2])[0];
                            sym.children[k].visible = true;
                        }
                        if (sym.children[k] && sym.children[k].name === "symSide") {
                            sym.children[k].visible = false
                        }
                        if (sym.children[k] && sym.children[k].name === "symBottom") {
                            sym.children[k].visible = false
                        }
                        if (sym.children[k] && sym.children[k].name === "symTop") {
                            sym.children[k].visible = false
                        }
                    }
                } else if (reels[i][j].includes("M")) {
                    for (let k: number = 0; k < sym.children.length; k++) {
                        if (sym.children[k] && sym.children[k].name === "symBackground") {
                            (sym.children[k] as PIXI.Sprite).texture = GameResources.getTextures(DragonTribeGameAssets.M_BG)[0];
                            (sym.children[k] as PIXI.Sprite).tint = this.getMSymTint(reels[i][j]);
                            sym.children[k].visible = true;

                        }
                        if (sym.children[k] && sym.children[k].name === "symSide") {
                            (sym.children[k] as PIXI.Sprite).texture = GameResources.getTextures(DragonTribeGameAssets.M_S)[0];
                            sym.children[k].visible = true;
                        }
                        if (sym.children[k] && sym.children[k].name === "symBottom") {
                            (sym.children[k] as PIXI.Sprite).texture = GameResources.getTextures(DragonTribeGameAssets.M_B)[0];
                            sym.children[k].visible = true;
                        }
                        if (sym.children[k] && sym.children[k].name === "symTop") {
                            (sym.children[k] as PIXI.Sprite).texture = GameResources.getTextures(DragonTribeGameAssets.M_T)[0];
                            sym.children[k].visible = true;
                        }
                    }
                } else if (reels[i][j].includes("S") || reels[i][j].includes("W")) {
                    const isScattter: boolean = reels[i][j].includes("S");
                    const texture: string = (isScattter ? DragonTribeGameAssets.S_BG : DragonTribeGameAssets.W_BG);
                    for (let k: number = 0; k < sym.children.length; k++) {
                        if (sym.children[k] && sym.children[k].name === "symBackground") {
                            (sym.children[k] as PIXI.Sprite).texture = GameResources.getTextures(texture)[0];
                            sym.children[k].visible = true;
                        }
                        if (sym.children[k] && sym.children[k].name === "symSide") {
                            (sym.children[k] as PIXI.Sprite).texture = GameResources.getTextures(isScattter ? DragonTribeGameAssets.S_S : DragonTribeGameAssets.W_S)[0];
                            sym.children[k].visible = true;
                        }
                        if (sym.children[k] && sym.children[k].name === "symBottom") {
                            (sym.children[k] as PIXI.Sprite).texture = GameResources.getTextures(isScattter ? DragonTribeGameAssets.S_B : DragonTribeGameAssets.W_B)[0];
                            sym.children[k].visible = true;
                        }
                        if (sym.children[k] && sym.children[k].name === "symTop") {
                            (sym.children[k] as PIXI.Sprite).texture = GameResources.getTextures(isScattter ? DragonTribeGameAssets.S_T : DragonTribeGameAssets.W_T)[0];
                            sym.children[k].visible = true;
                        }
                    }
                }
            }
        }
        EventHandler.dispatchEvent(new GameEvent(ServerEvent.GAME_DATA_RECEIVED, data));
        EventHandler.dispatchEvent(new GameEvent(ScreenEvent.GAME_START));
    }

    private getMSymTint(sym: string): number {
        switch (sym) {
            case "M1":
                return 0xff2323;
            case "M2":
                return 0xffa800;
            case "M3":
                return 0xaae41f;
            case "M4":
                return 0x1fa36a;
            case "M5":
                return 0x35e5df;
            case "M6":
                return 0x5867a9;
        }
        return 0xff2323;
    }

    private isBigWin(response: IDragonTribeGameData): boolean {
        const win = parseFloat(response.totalAvalancheRoundWinnings);
        const playedBetValue = parseFloat(response.playedBetValue);
        let winRatio: number = Helper.ceilToDecimals((win / playedBetValue), 5);

        if (response.wasFeatureBuy) {
            const betPrice: number = DragonTribeGameModuleConfig.featurePrice.getBuyFeaturePrice(playedBetValue, response.wasFeatureBuy)
            winRatio = Helper.ceilToDecimals((win / betPrice), 5);
            return winRatio >= 1;
        }

        return winRatio >= 15;
    }

    private getWin(response: IDragonTribeGameData, bet: number, prevData: IDragonTribeGameData): number {
        return parseFloat(response.totalAvalancheRoundWinnings);
    }

    private getFeatureName(response: IDragonTribeGameData): string {
        if (response.nextMode === "FREESPIN_PICK") {
            return "Pick Bonus Mode";
        }

        if (response.nextMode === GameMode.FREESPIN || response.mode === GameMode.FREESPIN_AVALANCHE || response.nextMode === GameMode.FREESPIN_AVALANCHE || response.mode === GameMode.FREESPIN || response.mode === "FREESPIN_PICK" || response.nextMode === "FREESPIN_PICK") {
            return response.playerFSSelection === 2 ? "DRAGON SPINS EXTREME" : "DRAGON SPINS";
        }
        return "";
    }

    private isFreeSpinTriggered(response: IDragonTribeGameData): boolean {
        // return (response.mode === GameMode.NORMAL_AVALANCHE || response.mode == GameMode.NORMAL) && response.nextMode == "FREESPIN_PICK";
        return response.freespinTriggeredThisSpin ? response.freespinTriggeredThisSpin : false;
    }

    private isRoundComplete(response: IDragonTribeGameData): boolean {
        return ([GameMode.NORMAL, GameMode.FREESPIN, "FREESPIN_PICK"].indexOf(response.nextMode) > -1);
    }

    private isBonusEnd(response: IDragonTribeGameData): boolean {
        return (response.mode === GameMode.FREESPIN || response.mode === GameMode.FREESPIN_AVALANCHE) && response.nextMode === GameMode.NORMAL;
    }

}